module.exports = __webpack_public_path__ + "static/media/MHei-Light.59ac6d99.svg";